export const createBlueprintMtn = /* GraphQL */ `
  mutation CreateBlueprint($input: CreateBlueprintInput!) {
    createBlueprint(input: $input) {
      createdAt
    }
  }
`

export const updateBlueprintMtn = /* GraphQL */ `
  mutation UpdateBlueprint($input: UpdateBlueprintInput!) {
    updateBlueprint(input: $input) {
      updatedAt
    }
  }
`

export const createSectionMtn = /* GraphQL */ `
  mutation CreateSection($input: CreateSectionInput!) {
    createSection(input: $input) {
      createdAt
    }
  }
`

export const updateSectionMtn = /* GraphQL */ `
  mutation UpdateSection($input: UpdateSectionInput!) {
    updateSection(input: $input) {
      updatedAt
    }
  }
`

export const deleteSectionMtn = /* GraphQL */ `
  mutation DeleteSection($input: DeleteSectionInput!) {
    deleteSection(input: $input) {
      updatedAt
    }
  }
`

export const getProjectBlueprintsQuery = /* GraphQL */ `
  query GetProjectBlueprints($id: ID!) {
    blueprintsByProject(projectBlueprintsId: $id, limit: 1000) {
      items {
        id
        name
        imageUrl
        projectBlueprintsId
        createdAt
        sections(limit: 1000) {
          items {
            id
          }
        }
      }
    }
  }
`

export const getProjectBlueprintSectionsForDuplicateQuery = /* GraphQL */ `
  query GetProjectBlueprintSectionsForDuplicate($id: ID!) {
    blueprintsByProject(projectBlueprintsId: $id, limit: 1000) {
      items {
        id
        name
        imageUrl
        projectBlueprintsId
        createdAt
        sections(limit: 1000) {
          items {
            id
            name
            type
            blueprintUrl
            sectionSubSectionsId
            translations(limit: 1000) {
              items {
                id
                lang
                label
              }
            }
          }
        }
      }
    }
  }
`

export const createShapeMtn = /* GraphQL */ `
  mutation CreateShape($input: CreateShapeInput!) {
    createShape(input: $input) {
      createdAt
    }
  }
`

export const updateShapeMtn = /* GraphQL */ `
  mutation UpdateShape($input: UpdateShapeInput!) {
    updateShape(input: $input) {
      updatedAt
    }
  }
`

export const deleteShapeMtn = /* GraphQL */ `
  mutation DeleteShape($input: DeleteShapeInput!) {
    deleteShape(input: $input) {
      updatedAt
    }
  }
`

export const getBlueprintQuery = /* GraphQL */ `
  query GetBlueprint($id: ID!) {
    getBlueprint(id: $id) {
      id
      name
      imageUrl
      projectBlueprintsId
      sections(limit: 1000) {
        items {
          id
          name
          type
          blueprintUrl
          sectionSubSectionsId
          translations {
            items {
              id
              lang
              label
            }
          }
        }
      }
    }
  }
`

export const getSectionQuery = /* GraphQL */ `
  query GetSection($id: ID!) {
    getSection(id: $id) {
      id
      name
      type
      blueprintSectionsId
      sectionSubSectionsId
      blueprintUrl
      translations {
        items {
          id
          lang
          label
        }
      }
      shapes(limit: 5000) {
        items {
          id
          area
          blueprintShapesId
          color
          comment
          endDate
          imageUrl
          length
          markerId
          name
          points {
            x
            y
          }
          rotation
          sectionShapesId
          sectionType
          parentShapesId
          startDate
          type
        }
      }
    }
  }
`

export const getSectionsQuery = /* GraphQL */ `
  query GetSections($id: ID!) {
    blueprintsByProject(projectBlueprintsId: $id, limit: 1000) {
      items {
        id
        name
        imageUrl
        projectBlueprintsId
        createdAt
        sections(limit: 1000) {
          items {
            id
            name
            type
            translations {
              items {
                id
                lang
                label
              }
            }
            shapes(
              limit: 1000
              filter: {
                or: [{ type: { eq: RECTANGLE } }, { type: { eq: FREEFORM } }]
              }
            ) {
              items {
                id
                name
                type
              }
            }
          }
        }
      }
    }
  }
`
